'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var adapter = require('./adapter.js');

const settings = {
  ADAPTER: adapter.BrowserAdapter,
  RESOLUTION: 1,
  CREATE_IMAGE_BITMAP: false,
  ROUND_PIXELS: false
};

exports.settings = settings;
//# sourceMappingURL=settings.js.map
